// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import MenuDrawerController from "./menu_drawer_controller"
application.register("menu-drawer", MenuDrawerController)

import TabLoaderController from "./tab_loader_controller"
application.register("tab-loader", TabLoaderController)

import KeywordsController from "./keywords_controller"
application.register("keywords", KeywordsController)
